const isInFavorites = (id: number, favorites: { list: Material[] }) => {
    return Boolean(favorites.list.find((favoriteItem: Material) => favoriteItem.id === id));
};

export default isInFavorites;
